import conf from '~/app/conf'
import { IAxiosClientError } from '~/app/react-query/axios'
import { getYaNative } from '@yanolja-org/ya-native'
import { isNative } from '~/app/utils/typeguards'

/**
 * @summary 해외주문 공통 Axios 에러 핸들러
 * @description
 * - 401: 비회원 예약 내역 조회 페이지로 이동
 * - 그 외: 각 페이지에서 처리
 * @param error - IAxiosClientError
 */
const globalErrorHandler = (error: IAxiosClientError) => {
  const { status, data } = error.response
  if (status === 401) {
    // 기본 값: 비회원 예약 내역 조회 페이지로 이동
    const { isMemberOrder } = data.data ?? { isMemberOrder: false }

    const redirectUrl = encodeURIComponent(
      `${window.location.origin}${window.location.pathname}${window.location.search}`
    )
    if (isMemberOrder) {
      const yaNative = getYaNative()
      if (isNative(yaNative)) {
        yaNative.login()
        return
      }

      window.location.replace(`${conf.web.url}/login?redirect=${redirectUrl}`)
    } else {
      // 신규 비회원 예약 조회 페이지(platform-site /visitor-login)로 이동.
      // 페이지 SSR이 feature flag off 시 레거시 visitorlogin으로 폴백하므로 분기 불필요.
      const query = new URLSearchParams({ type: 'global' })
      window.location.replace(`/visitor-login?${query.toString()}`)
    }
    return
  }
}

export default globalErrorHandler
